import { required } from "vuelidate/lib/validators";

const schemas = {
  client: {
    name: {
      required,
    },
  },
  provider: {
    contact_person: {
      required,
    },
    phone: {
      required,
    },
    name: {
      required,
    },
  },
  requisites: {
    INN: {
      required,
    },
  },
};

export default schemas;



// WEBPACK FOOTER //
// ./src/business/validation-schemas/index.js